import React from 'react'
import { SettingRow } from '../setting-row/setting-row'
import { Input } from '@shared/ui/input/input'
import { queryClient } from '@shared/api/query-client'
import s from './phone-setting.module.scss'

export const PhoneSetting = () => {
	const {data: profile} = queryClient.getQueryData(['profile'])

	return (
		<SettingRow centered title={'Телефон'}> 
			<Input
					name="null"
					placeholder="+7 (999) 999 99-99"
					className={s.input}
					disabled
					value={profile?.phone}
				/>
		</SettingRow>
	)
}
